import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import i18n from "./i18n"
import Vuex from 'vuex'

import {
  LayoutPlugin, 
  ModalPlugin,
  ButtonPlugin,
  FormPlugin, 
  FormCheckboxPlugin, 
  FormFilePlugin,
  FormGroupPlugin,
  FormInputPlugin, 
  InputGroupPlugin, 
  FormSelectPlugin,
  FormTextareaPlugin, 
  TablePlugin, 
  FormRadioPlugin,
  ToastPlugin,
  BadgePlugin,
  AlertPlugin,
  CardPlugin,
  SpinnerPlugin,
  TabsPlugin,
  IconsPlugin
} from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import VueDayjs from 'vue-dayjs-plugin'
import 'dayjs/locale/fr'

import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

Vue.config.productionTip = false

Vue.use(Vuex)


Vue.use(LayoutPlugin)
Vue.use(ModalPlugin)
Vue.use(ButtonPlugin)
Vue.use(FormPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormFilePlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(InputGroupPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(TablePlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormRadioPlugin)
Vue.use(ToastPlugin)
Vue.use(BadgePlugin)
Vue.use(AlertPlugin)
Vue.use(CardPlugin)
Vue.use(SpinnerPlugin)
Vue.use(TabsPlugin)
Vue.use(IconsPlugin)

Vue.use(VueDayjs)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCfv12X5o9y7vo6vUXc7Fj3k9h2fMLaPys',
    libraries: 'visualization', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})

Vue.component('GmapCluster', GmapCluster)

Vue.component('custom-loading-component', Loading)

Vue.prototype.$eventHub = new Vue()

// A prerendered snapshot can carry a Bootstrap-Vue overlay baked into <body>,
// outside of #app (see webapp/scripts/prerender.js). Mounting over #app leaves
// that markup on screen with no listener able to close it, so the visitor gets
// a popup whose cross and backdrop do nothing, over a page the `modal-open`
// scroll lock has frozen (ticket #29). Snapshots are clean from now on, but
// browsers and caches still hold the old ones: anything on screen before the
// app boots is static markup by definition, so drop it.
document
  .querySelectorAll('[id$="___BV_modal_outer_"], .modal, .modal-backdrop')
  .forEach(el => el.remove())
document.body.classList.remove('modal-open')
document.body.removeAttribute('data-modal-open-count')
document.body.style.removeProperty('overflow')
document.body.style.removeProperty('padding-right')

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')


